module.exports = __webpack_public_path__ + "static/media/google_chrome.8fa629ad.png";